const initShareLink = () => {
    const shareLinks = document.querySelectorAll("[data-share]");
    if (shareLinks && shareLinks.length > 0) {
        const socialWindow = (url) => {
            const left = (screen.width - 570) / 2;
            const top = (screen.height - 570) / 2;
            const params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
            window.open(url, "NewWindow", params);
        };
        const setShareLinks = () => {
            const activeURL = window.location.href;
            const pageUrl = encodeURIComponent(activeURL);
            const tweet = encodeURIComponent(document.querySelector("meta[property='og:description']").getAttribute("content"));
            const facebookLink = document.querySelector("[data-share-facebook]");
            const linkedinLink = document.querySelector("[data-share-linkedin]");
            const twitterLink = document.querySelector("[data-share-twitter]");
            const anchorLink = document.querySelector("[data-share-anchor]");
            facebookLink.addEventListener("click", () => {
                const url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
                socialWindow(url);
            });
            twitterLink.addEventListener("click", () => {
                const url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + tweet;
                socialWindow(url);
            });
            linkedinLink.addEventListener("click", () => {
                const url = "https://www.linkedin.com/shareArticle?mini=true&url=" + pageUrl;
                socialWindow(url);
            });
            anchorLink.addEventListener("click", () => {
                const url = activeURL;
                navigator.clipboard.writeText(url);
            });
        };
        setShareLinks();
    }
};
